<header>
  Nova proposta
  <p class="font-12">Saiba se o cliente já é cadastrado</p>
</header>
<mat-dialog-content class="mat-typography py-1">
  <div>
    <strong class="text-primary font-12">CNPJ/CPF</strong>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="document"
      (ngModelChange)="verifyDocumentExists()"
      [brmasker]="{person: true}"
      [ngClass]="{'is-valid': typeError.existClient, 'is-invalid': typeError.notExistClient || typeError.existClientOtherBase}"
    />
  </div>
  <div class="text-success font-12" *ngIf="typeError.existClient">Esse cliente já está cadastrado.</div>
  <div class="text-danger font-12" *ngIf="typeError.existClientOtherBase">
    Cliente já cadastrado por outro Banker Mais digital.
  </div>
  <div class="text-danger font-12" *ngIf="typeError.notExistClient">Esse cliente não está cadastrado.</div>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex float-right">
  <a type="button" class="mr-3 cancel-button-color" (click)="close()">CANCELAR</a>
  <a type="button" class="mr-3 text-primary" (click)="newPropose()" *ngIf="typeError.existClient">NOVA PROPOSTA</a>
  <a type="button" class="mr-3 text-primary" (click)="createClient()" *ngIf="typeError.notExistClient">CRIAR CLIENTE</a>
</mat-dialog-actions>
